import { Heading } from '@televet/kibble-ui/build/components/Heading';
import { HStack } from '@televet/kibble-ui/build/chakra';
import { Checkbox } from '@televet/kibble-ui/build/components/Checkbox';
import React, { useCallback } from 'react';
import { BoardFilterView, UpdateUserBoardFilterSettingsMutationFn } from 'shared/types/graphql';
import ConversationStatusFilterMenu from './ConversationStatusFilterMenu';
import DateRangeFilter from './DateRangeFilter';
import ViewToggle from './ViewToggle';
import { useAppSelector } from 'state/hooks';
import ProcessTracker from 'shared/components/Layouts/DefaultAuthenticated/components/ProcessTracker';

interface BoardHeaderProps {
  updateBoardSettings: UpdateUserBoardFilterSettingsMutationFn;
}

const BoardHeader = ({ updateBoardSettings }: BoardHeaderProps): JSX.Element => {
  const { boardSettings, clinicUserId, currentClinicId } = useAppSelector((state) => state.board);

  const handleChangeShouldHideEmptyColumns = useCallback(async () => {
    await updateBoardSettings({
      variables: {
        where: {
          userId: clinicUserId || '',
          clinicId: currentClinicId || '',
        },
        data: {
          shouldHideEmptyColumns: !boardSettings?.shouldHideEmptyColumns,
        },
      },
    });
  }, [boardSettings?.shouldHideEmptyColumns, clinicUserId, currentClinicId, updateBoardSettings]);

  return (
    <>
      <HStack
        p={5}
        h={14}
        backgroundColor="background.default"
        borderBottom="1px"
        borderBottomColor="border.default"
        justify="space-between"
        w="100%"
      >
        <Heading size="md">Board</Heading>
        <HStack>
          <ViewToggle updateBoardSettings={updateBoardSettings} />
          {currentClinicId && <ProcessTracker />}
        </HStack>
      </HStack>
      <HStack
        className="Board__Header"
        justify="space-between"
        align="center"
        wrap="wrap"
        px={5}
        py={2}
        pos="relative"
        rowGap={2}
        w="100%"
        zIndex="banner"
      >
        <HStack className="Board__Header--Left" justify="center" align="center">
          {boardSettings?.currentView !== BoardFilterView.Automations && (
            <>
              <ConversationStatusFilterMenu updateBoardSettings={updateBoardSettings} />
              <Checkbox
                id="board-auto-remove-checkbox"
                isChecked={boardSettings?.shouldHideEmptyColumns || false}
                size="sm"
                onChange={handleChangeShouldHideEmptyColumns}
              >
                Hide empty columns
              </Checkbox>
            </>
          )}
        </HStack>
        <HStack className="Board__Header--Right" pos="relative">
          <DateRangeFilter updateBoardSettings={updateBoardSettings} />
        </HStack>
      </HStack>
    </>
  );
};

export default BoardHeader;
